import { configureStore } from '@reduxjs/toolkit'

import appApi from './api'
import notificationPanelReducer from './slice/NotificationPanel'



export const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(appApi.middleware),
  reducer: {
    [appApi.reducerPath]: appApi.reducer,
    notificationPanel: notificationPanelReducer,
  }
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export default store
